import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl, ipAddress, userName,} from "../Univ";
import "bootstrap/dist/css/bootstrap.min.css";
function MachineUsage() {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [bookingList, setBookingList] = useState([]);
    const [formData, setFormData] = useState({
        booking: "",
        work_date: "",
        worked_quantity: "",
        diesel_used: "",
        remarks: "",
        addedby: userName,
        ip_add: ipAddress,
    });
    useEffect(() => {
        getMachineBooking();
        getMachineUsage();
    }, []);
    const getMachineBooking = () => {
        axios
            .get(baseUrl + "machine-booking/")
            .then((res) => {
                setBookingList(res.data);
            });
    };
    const getMachineUsage = () => {
        setLoading(true);
        axios
            .get(baseUrl + "machine-usage/")
            .then((res) => {
                setRows(res.data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                Swal.fire({
                    icon: "error", title: "Error", text: "Unable to load Machine Usage records.",
                });
            });
    };
    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData({
            ...formData, [name]: value,
        });
    };
    const clearForm = () => {
        setFormData({
            booking: "",
            work_date: "",
            worked_quantity: "",
            diesel_used: "",
            remarks: "",
            addedby: userName,
            ip_add: ipAddress,
        });
    };
    const saveMachineUsage = () => {
        const data = new FormData();
        data.append("booking", formData.booking);
        data.append("work_date", formData.work_date);
        data.append("worked_quantity", formData.worked_quantity);
        data.append("diesel_used", formData.diesel_used);
        data.append("remarks", formData.remarks);
        data.append("addedby", userName);
        data.append("ip_add", ipAddress);
        setLoading(true);
        axios
            .post(baseUrl + "machine-usage/", data)
            .then(() => {
                Swal.fire({
                    icon: "success", title: "Success", text: "Machine Usage saved successfully.",
                });
                clearForm();
                getMachineUsage();
            })
            .catch(() => {
                setLoading(false);
                Swal.fire({
                    icon: "error", title: "Error", text: "Unable to save Machine Usage.",
                });
            });
    };
    const deleteMachineUsage = (id) => {
        Swal.fire({
            title: "Delete Machine Usage?",
            text: "You won't be able to revert this.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                axios
                    .delete(`machine-usage/${id}/`)
                    .then(() => {
                        Swal.fire({
                            icon: "success", title: "Deleted", text: "Machine Usage deleted successfully.",
                        });
                        getMachineUsage();
                    })
                    .catch(() => {
                        setLoading(false);
                        Swal.fire({
                            icon: "error", title: "Error", text: "Unable to delete Machine Usage.",
                        });
                    });
            }
        });
    };
    const columns = [{
        field: "id", headerName: "ID", width: 80,
    }, {
        field: "booking_no", headerName: "Booking",
        width: 180,
        renderCell: (params) => params.row.booking?.machine.machine_name || ""
    }, {
        field: "work_date", headerName: "Work Date", width: 130,
    }, {
        field: "worked_quantity", headerName: "Worked Qty", width: 140,
    }, {
        field: "diesel_used", headerName: "Diesel Used", width: 140,
    }, {
        field: "remarks", headerName: "Remarks", flex: 1,
    },];
    return (
        <div className="container-fluid mt-3">

            <div className="card shadow">

                <div className="card-header bg-primary text-white">

                    <h5 className="mb-0">
                        Machine Usage
                    </h5>

                </div>

                <div className="card-body">

                    <div className="row">

                        <div className="col-md-6 mb-3">

                            <label>Machine Booking</label>

                            <select
                                className="form-select"
                                name="booking"
                                value={formData.booking}
                                onChange={handleChange}
                            >
                                <option value="">
                                    Select Booking
                                </option>

                                {bookingList.map((item) => (
                                    <option
                                        key={item.id}
                                        value={item.id}
                                    >
                                        {item.machine.machine_name}
                                    </option>
                                ))}

                            </select>

                        </div>

                        <div className="col-md-3 mb-3">

                            <label>Work Date</label>

                            <input
                                type="date"
                                className="form-control"
                                name="work_date"
                                value={formData.work_date}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-md-3 mb-3">

                            <label>Worked Quantity</label>

                            <input
                                type="number"
                                className="form-control"
                                name="worked_quantity"
                                value={formData.worked_quantity}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-md-4 mb-3">

                            <label>Diesel Used</label>

                            <input
                                type="number"
                                className="form-control"
                                name="diesel_used"
                                value={formData.diesel_used}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-md-8 mb-3">

                            <label>Remarks</label>

                            <textarea
                                className="form-control"
                                rows="2"
                                name="remarks"
                                value={formData.remarks}
                                onChange={handleChange}
                            />

                        </div>

                        <div className="col-md-12 mt-3">

                            <button
                                className="btn btn-success me-2"
                                onClick={saveMachineUsage}
                                disabled={loading}
                            >
                                Save
                            </button>

                            <button
                                className="btn btn-secondary"
                                onClick={clearForm}
                            >
                                Clear
                            </button>

                        </div>

                    </div>
                    <div className="card shadow mt-3">

                        <div className="card-header bg-primary text-white">

                            <h5 className="mb-0">
                                Machine Usage List
                            </h5>

                        </div>

                        <div className="card-body">

                            <div
                                style={{
                                    height: 600, width: "100%",
                                }}
                            >

                                <ERPDataGrid
                                    rows={rows}
                                    columns={columns}
                                    loading={loading}
                                    getRowId={(row) => row.id}
                                    pageSizeOptions={[10, 25, 50, 100,]}
                                    
                                    disableRowSelectionOnClick
                                />

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>
    );
}
export default MachineUsage;